// extracted by mini-css-extract-plugin
export default {"item":"LocalityInput_item__R0wcC"};